const SIGNUP_STAGES = {
    FIND_COMPANY: 'FIND_COMPANY',
    CREATE_PROFILE:  'CREATE_PROFILE',
    CREATE_ACCOUNT: 'CREATE_ACCOUNT'
};
Object.freeze(SIGNUP_STAGES);

export { SIGNUP_STAGES };